module.exports = __webpack_public_path__ + "img/logo-vertical.a2a01988.png";